import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { OnboardPrivateScreen } from 'screens/patient';

export default withPermissions(OnboardPrivateScreen, [
  GroupSecurity.PatientCreate,
]);
